import React, { memo, forwardRef, useImperativeHandle, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";

import api from "services/api";
import { promptAlertMessage } from "store/slices/alert";
import serveRequestErrors from "common/serve-request-errors";
import AppButton from "components/app-button";

export const AppRefreshLeaveModal = (props, ref) => {
    const dispatch = useDispatch();
    const [visible, setVisible] = useState(false);
    const [isSubmiting, setIsSubmiting] = useState(false);

    const onHandleShow = useCallback(() => {
        setVisible(true);
    }, []);

    const onHandleDismiss = useCallback(() => {
        setVisible(false);
    }, []);

    //prettier-ignore
    const onHandleConfirm = useCallback(async () => {
        let response = null;

        setIsSubmiting(true);

        try {
            await api.post.claims.refresh(new Date().getFullYear());
            response = true;
        } catch (error) {
            serveRequestErrors(error);
        } finally {
            setIsSubmiting(false);
        }

        if (response) {
            onHandleDismiss();
            dispatch(promptAlertMessage({ message: "Claim has been reset successfully" }));
            props.onHandleGetList()
        }
    }, [dispatch, onHandleDismiss, props]);

    //prettier-ignore
    useImperativeHandle(ref, () => ({
        onHandleShow: onHandleShow,
        onHandleDismiss: onHandleDismiss,
    }));

    return (
        <Modal classes={{ root: "app-refresh-claim-modal" }} open={visible} onClose={onHandleDismiss} aria-labelledby="refresh-claim-modal" aria-describedby="refresh-claim-modal">
            <div className="refresh-claim-modal">
                <div className="refresh-claim-modal__main">
                    <div className="refresh-claim-modal__header">
                        <p className="refresh-claim-modal__title">Reset Claims</p>
                        <p className="refresh-claim-modal__description">Claim reset updates all the employees’ claim balance and claims taken for all claim types. Please ensure that all pending claims are resolved.</p>
                    </div>

                    <div className="refresh-claim-modal__button-container">
                        <AppButton type="button" label="Cancel" outline onClick={onHandleDismiss} disabled={isSubmiting} />
                        <AppButton type="button" label="Confirm" onClick={onHandleConfirm} disabled={isSubmiting} />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default memo(forwardRef(AppRefreshLeaveModal));

AppRefreshLeaveModal.propTypes = {
    ref: PropTypes.object,
};
